/**
 * Wacht tot een DOM-element bestaat en stabiel is
 * @param {string} selector - CSS selector
 * @param {Function} callback - Wordt aangeroepen zodra element bestaat
 * @param {number} timeout - max wachttijd (ms)
 */
export function waitForDomElement(selector, callback, timeout = 3000) {
  const start = Date.now();

  function check() {
    const el = document.querySelector(selector);
    if (el) {
      callback(el);
      return;
    }

    if (Date.now() - start > timeout) {
      console.warn(`⏳ waitForDomElement timeout: ${selector}`);
      return;
    }

    requestAnimationFrame(check);
  }

  check();
}
